<div class="d-flex" id="wrapper">
  <div class="sidenav">
    <app-sidebar></app-sidebar>
  </div>
  <div class="router-outlet">
    <router-outlet></router-outlet>
  </div>
</div>
